<!--page starts-->
<section class="page-wrapper">
    <section class="vitalityblast-hero-section margin-top-152 cf">
        <div class="club-fischer-bottom-contact-section">
            <div class="commercial-bottom-contact-form" style="background-image: url(assets/images/vitality-banner.png);">
                <div class="container">
                    <div class="titel-box">
                        <h2 class="titel-name">Join our mailing list</h2>
                    </div>
                    <div class="commercial-bottom-contact-detail">
                        <form class="commercialform" #newsletterForm="ngForm" (ngSubmit)="clubContactus(newsletterForm)" [ngClass]="{'success': contactSuccess}">
                            <http-message types="success" [data]="contactSuccess" class="err-msg-block">
                            </http-message>
                            <http-message [type]="'error'" [data]="contactError" *ngIf="contactError"
                               class="err-msg-block"></http-message>
                            <div class="join-register-right-box">
                                <div class="join-register-right-box-input half">
                                    <app-form-field validation="required" name="first_name" [(ngModel)]="contactRequest.first_name"
                               class="app-group">
                                        <input appFieldInput tabindex="1" class="register-style" placeholder="First Name" type="text">
                                    </app-form-field>
                                </div>
                                <div class="join-register-right-box-input half">
                                    <app-form-field validation="required" name="last_name" [(ngModel)]="contactRequest.last_name"
                               class="app-group">
                                        <input appFieldInput tabindex="1" class="register-style" placeholder="Last Name" type="text">
                                    </app-form-field>
                                </div>
                            </div>
                            <div class="join-register-right-box">
                                <div class="join-register-right-box-input">
                                    <app-form-field validation="required" name="email" [(ngModel)]="contactRequest.email"
                               class="app-group">
                                        <input appFieldInput tabindex="2" class="register-style" placeholder="Email Address" type="text">
                                    </app-form-field>
                                </div>
                            </div>
                            <div class="join-register-right-box">
                                <div class="join-register-right-box-checkbox">
                                    <label class="vitality-checkbox">By submitting information you agree to our Terms of Use &
                                        Privacy Policy
                                        <input tabindex="10" type="checkbox" checked id="email_notiification">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="join-register-right-box">
                                <div class="join-register-btn"><button  tabindex="11" id="reg_button" type="submit">REGISTER</button></div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="commercial-bottom-contact-overlay"></div>
            </div>
        </div>
    </section>
</section><!-- page ends-->